const metaAuth = {
  auth: 1,
  keepAlive: false,
};

export default [
  {
    path: "/yx3605",
    name: "yx3605",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/sougou3",
    name: "sougou3",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/sougou2",
    name: "sougou2",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/ibaidu",
    name: "ibaidu",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/msougou2",
    name: "msougou2",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/uc4",
    name: "uc4",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/uc3",
    name: "uc3",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/zdzm",
    name: "zdzm",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/wm",
    name: "wm",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/msougou1",
    name: "msougou1",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/m996",
    name: "m996",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/360m/001",
    name: "360m/001",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/kuaishou",
    name: "kuaishou",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/wangyiyixiao",
    name: "wangyiyixiao",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/dxaiqiyi",
    name: "dxaiqiyi",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/jyaiqiyi",
    name: "jyaiqiyi",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/jiayinwangyiyunyinyue",
    name: "jiayinwangyiyunyinyue",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/jiayinwangyixinwen",
    name: "jiayinwangyixinwen",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/360m",
    name: "360m",
    meta: metaAuth,
    component: () => import("@/views/baseWeb/index.vue"),
  },
  {
    path: "/namim",
    name: "namim",
    meta: metaAuth,
    component: () => import("@/views/baseWeb/index.vue"),
  },
  {
    path: "/sigmob1",
    name: "sigmob1",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/baidu9",
    name: "baidu9",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/yykp",
    name: "yykp",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/yyzb",
    name: "yyzb",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/yx3607",
    name: "yx3607",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/yx3606",
    name: "yx3606",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/uc1",
    name: "uc1",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/zb1",
    name: "zb1",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/zb2",
    name: "zb2",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/zb3",
    name: "zb3",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/zb4",
    name: "zb4",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/zb5",
    name: "zb5",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/fengchaom",
    name: "fengchaom",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/baiduwangpan",
    name: "baiduwangpan",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/haokanshipin",
    name: "haokanshipin",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/lhfs",
    name: "lhfs",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/pddh",
    name: "pddh",
    meta: metaAuth,
    component: () => import("@/views/baseMb/index.vue"),
  },
  {
    path: "/bym",
    name: "bym",
    meta: metaAuth,
    component: () => import("@/views/baseWeb/index.vue"),
  },
  {
    path: "/siyu",
    name: "siyu",
    meta: metaAuth,
    component: () => import("@/views/baseWeb/index.vue"),
  },
  {
    path: "/siyu1",
    name: "siyu1",
    meta: metaAuth,
    component: () => import("@/views/baseWeb/index.vue"),
  },
  {
    path: "/xunlei",
    name: "xunlei",
    meta: metaAuth,
    component: () => import("@/views/baseWeb/index.vue"),
  },
  {
    path: "/ks",
    name: "ks",
    meta: metaAuth,
    component: () => import("@/views/baseWeb/index.vue"),
  },
  {
    path: "/lhws",
    name: "lhws",
    meta: metaAuth,
    component: () => import("@/views/baseWeb/index.vue"),
  },
];
